import React, { useState, useEffect } from "react";
import EnquiryForm from "../components/EnquiryForm";
import EnquiryPopup from "../components/EnquiryPopup";
import WheelLoaderAuthorizedDealers from "../components/WheelLoaderAuthorizedDealers";
import WheelLoaderNewHeroCarousel from "../components/WheelLoaderNewHeroCarousel";
import WheelLoaderWhyChoose from "../components/WheelLoaderWhyChoose";
import WlCardComponent from "../components/WlCardComponent";
import WheelLoaderProductsComponent from "../components/WheelLoaderProductsComponent";
import WheelLoader from "../components/WheelLoader";
import { fetchPhoneNumberInformation } from "../services/api";
import TopProducts from "../components/TopProducts"
import { Link } from "react-router-dom";
const WheelLoaderPage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [phoneData, setPhoneData] = useState(null);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const loadPhoneData = async () => {
      try {
        const data = await fetchPhoneNumberInformation();
        setPhoneData(data);
      } catch (error) {
        console.error('Error fetching phone number information:', error);
      }
    };

    loadPhoneData();
  }, []);

  return (
    <div>
      <WheelLoaderAuthorizedDealers/> 
    <WheelLoaderNewHeroCarousel phoneData={phoneData} />     
      <WheelLoaderWhyChoose/>
      <section className="py-8 sm:py-16 bg-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-8 lg:mb-12">
              <h2 className="text-4xl sm:text-3xl lg:text-4xl xl:text-5xl font-normal text-gray-900 mb-2">What’s <span className="font-semibold">Special</span> about <span className="font-semibold">Hengwang</span>?
      </h2>
            </div>
              
              <WlCardComponent />
      
              </div>
            </section>

                {/* Enquiry Form  Section    */}
      <section className="py-8 sm:py-16 bg-neutral-50" style={{boxShadow: '0px -11px 50px 2px #0000001C'
}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <EnquiryForm title={<>Need the<br className="hidden sm:block"/><span className="font-semibold">{" "}Right Wheel Loader?</span></>} content={<><p className="text-lg lg:text-[22px] mb-8 text-white leading-relaxed">
            Get <span className="font-semibold">expert advice</span>, <span className="font-semibold">quick quotes</span>, and the <span className="font-semibold">best deals</span> — all in one
            place.
          </p>
          <p className="text-lg lg:text-[22px] mb-8 text-white leading-relaxed">
            Enquire now and let{" "}
            <span className="font-semibold">Golden Sparrow</span>
            <br className="hidden sm:block"/>
            {" "}lift your business higher.
          </p></>}
          backgroundImage="./images/wheelLoader/wheelLoader_form.webp" tagLine={<p className="text-center text-sm sm:text-sm italic text-black mt-6 sm:mt-12 max-w-xs sm:max-w-sm md:max-w-[300px] mx-auto px-2">Get Your Wheel Loader Price Today – Response <span className="font-semibold">within 1 hour</span></p>} />
      </div>
      </section>

            {/* Bestselling Recommended Products Section Start Here  */}
            <section className="py-8 sm:py-16">
              <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
                <div className="recommended-products-header">
                  <h2 className="recommended-products-title">
                    <span className="recommended-products-title--bold">Bestselling Recommended</span> Products
                  </h2>
                  <div className="hidden sm:flex items-end">
                    <img src="/images/logos/authorized_dealer_stamp_1.png" alt="Stamp" />
                  </div>
                </div>
              <TopProducts productIds={['gs1450', 'gs1452', 'gs1452']} gridCols={{ sm: 3, lg: 3, xl: 3 }} />
              <div className='flex justify-center items-center'>
                          <Link to="/products?taxonomy=equipment-buy&term=wheel-loaders&termName=Wheel%20Loaders" className="font-semibold gradient-text">View more Listing <span className="chevronRight"></span></Link>
                        </div>
            </div>
            </section>
      
            {/* Bestselling Recommended Products Section End Here  */}

      {/* Banner Section */}
      <section className="hidden sm:block forklift-bnrx py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex sm:justify-start">
          <div className="max-w-max">
          <h2 className="text-2xl md:text-5xl lg:text-5xl font-normal text-white leading-normal mb-2">
            <span className="font-bold">Hengwang Loaders</span>
          </h2>
          <p className="text-lg md:text-xl text-white font-medium leading-relaxed mb-8">Shortlisted loaders that deliver powerful results.</p>
 
<ul className="flex flex-col gap-2 mb-6">
        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Built to perform in toughest conditions.</span>
          </p>
         </li>
 
        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Advanced technology for safety & efficiency.</span>
          </p>
        </li>
        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Trusted by professionals in 120+ countries.</span>
          </p>
        </li>
</ul>

 
{phoneData?.acf?.phone_wheelloaders && (
  <div className="inline-flex flex-col sm:flex sm:flex-row gap-4 mt-4">
    {/* <button onClick={handleOpenPopup} className="inline-flex items-center justify-center bg-[#FFC501] text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 rounded-md hover:bg-yellow-500 focus:bg-yellow-600 focus:outline-none focus:ring-4 focus:ring-yellow-300 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Call to action button" >Request a quote</button> */}
    <a href={`tel:+${phoneData?.acf?.phone_wheelloaders}`} className="quoteNowBtn inline-flex items-center justify-center gap-3 text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 rounded-md focus:outline-none transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Call to action button" ><span><img
                    src="/images/icons/phone_black.png"
                    alt=""
                    width="20"
                    height="20"
                  /></span>
                  <span>Get Quote Now</span></a>
  </div>
)}
 </div>          
        </div>


        <style>{`
            .forklift-bnrx {
    padding: 3em 0;
    background:
        url('./images/wheelLoader/wheelLoader_slide_3.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.quoteNowBtn {
            background: linear-gradient(
              159.21deg,
              #ffd200 11.19%,
              #f7971e 101.23%
            );
            outline: none;
            border: none;
          }

          .quoteNowBtn:hover,
          .quoteNowBtn:active {
            background: linear-gradient(
              159.21deg,
              #f7971e 11.19%,
              #ffd200 101.23%
            );
          }

@media screen and (max-width:768px){
.forklift-bnrx {
        background:
            linear-gradient(rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.68)),
            url('./images/wheelLoader/wheelLoader_slide_3.webp');
        background-size: cover;
        background-position: center;
    }
}
        
        `}</style>
      </section>
      <WheelLoader phoneData={phoneData} />

      {/* Enquiry Popup */}
      <EnquiryPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
    </div>
  );
};
export default WheelLoaderPage;
